"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRegulatoryAssessmentAdminDto = instanceOfRegulatoryAssessmentAdminDto;
exports.RegulatoryAssessmentAdminDtoFromJSON = RegulatoryAssessmentAdminDtoFromJSON;
exports.RegulatoryAssessmentAdminDtoFromJSONTyped = RegulatoryAssessmentAdminDtoFromJSONTyped;
exports.RegulatoryAssessmentAdminDtoToJSON = RegulatoryAssessmentAdminDtoToJSON;
exports.RegulatoryAssessmentAdminDtoToJSONTyped = RegulatoryAssessmentAdminDtoToJSONTyped;
/**
 * Check if a given object implements the RegulatoryAssessmentAdminDto interface.
 */
function instanceOfRegulatoryAssessmentAdminDto(value) {
    if (!('assessmentId' in value) || value['assessmentId'] === undefined)
        return false;
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('active' in value) || value['active'] === undefined)
        return false;
    return true;
}
function RegulatoryAssessmentAdminDtoFromJSON(json) {
    return RegulatoryAssessmentAdminDtoFromJSONTyped(json, false);
}
function RegulatoryAssessmentAdminDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'assessmentId': json['assessmentId'],
        'code': json['code'],
        'name': json['name'],
        'active': json['active'],
    };
}
function RegulatoryAssessmentAdminDtoToJSON(json) {
    return RegulatoryAssessmentAdminDtoToJSONTyped(json, false);
}
function RegulatoryAssessmentAdminDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'assessmentId': value['assessmentId'],
        'code': value['code'],
        'name': value['name'],
        'active': value['active'],
    };
}
//# sourceMappingURL=RegulatoryAssessmentAdminDto.js.map